<template lang="pug">
    section
        el-row.no-padding(:gutter="40")
            el-col(:lg="12" :md="24")
                el-row.no-padding(:gutter="20")
                    el-col(:lg="6" :md="6")
                        el-form-item(:label="$t('Salutation')" prop="gender")
                            el-select.is-full-width(placeholder="" v-model="gender")
                                el-option(:label="$t('Mr.')" value="M")
                                el-option(:label="$t('Mrs.')" value="F")
                                el-option(:label="$t('Undefined')" value="X")
                    el-col(:lg="9" :md="9")
                        el-form-item(:label="$t('First name')" prop="first_name")
                            el-input(v-model="firstName" maxlength="255" show-word-limit)
                    el-col(:lg="9" :md="9")
                        el-form-item(:label="$t('Last name')" prop="last_name")
                            el-input(v-model="lastName" maxlength="255" show-word-limit)
                .password-reset-flex-col
                    el-form-item.switch(v-if="isUpdate && isSuperUser" size="mini" label=" ")
                        el-switch(
                            :active-text="$t('Change password')"
                            inactive-color="#ff4949"
                            v-model="changePassword"
                        )
                    el-form-item.input(v-if="! isUpdate || changePassword" :label="$t('Password')" prop="password")
                        el-input(v-model="password" show-password ref="password" maxlength="255" show-word-limit)
            el-col(:lg="12" :md="24")
                el-row.no-padding(:gutter="20")
                    el-col(:lg="12" :md="12")
                        el-form-item(:label="$t('Email')" prop="email")
                            el-input(v-model="email" maxlength="255" show-word-limit)
                    el-col(:lg="12" :md="12")
                        el-form-item(:label="$t('Phone')" prop="phone")
                            el-input(v-model="phone" maxlength="255" show-word-limit)
                el-form-item(:label="$t('Company')" prop="company")
                    el-input(v-model="company" maxlength="255" show-word-limit)
</template>

<i18n>
{
    "de": {
        "Salutation": "Anrede",
        "First name": "Vorname",
        "Last name": "Nachname",
        "Email": "E-Mail",
        "Change password": "Passwort ändern",
        "Password": "Passwort",
        "Phone": "Telefon",
        "Company": "Firma",
        "Mr.": "Herr",
        "Mrs.": "Frau",
        "Undefined": "Unbekannt"
    }
}
</i18n>

<script>
import _ from 'lodash';
// import Vue from 'vue'
import { mapGetters } from 'vuex';

import store from '@/store';

export default {
    name: 'Main',
    components: {},
    computed: {
        gender: {
            get() {
                return _.get(this.form, 'gender', '');
            },
            set: value => store.commit('account/form/gender', value)
        },
        firstName: {
            get() {
                return _.get(this.form, 'first_name', '');
            },
            set: value => store.commit('account/form/firstName', value)
        },
        lastName: {
            get() {
                return _.get(this.form, 'last_name', '');
            },
            set: value => store.commit('account/form/lastName', value)
        },
        email: {
            get() {
                return _.get(this.form, 'email', '');
            },
            set: value => store.commit('account/form/email', value)
        },
        changePassword: {
            get() {
                return _.get(this.form, 'changePassword', false);
            },
            set(value) {
                store.commit('account/form/changePassword', value);
                if (value) {
                    this.$nextTick(() => {
                        const el = this.$refs.password.$el;
                        const input = el.getElementsByTagName('input');
                        if (input.length) input[0].select();
                    });
                }
            }
        },
        password: {
            get() {
                return _.get(this.form, 'password', '');
            },
            set: value => store.commit('account/form/password', value)
        },
        phone: {
            get() {
                return _.get(this.form, 'phone', '');
            },
            set: value => store.commit('account/form/phone', value)
        },
        company: {
            get() {
                return _.get(this.form, 'company', '');
            },
            set: value => store.commit('account/form/company', value)
        },
        isUpdate() {
            return !!_.get(this.form, 'id');
        },
        ...mapGetters({
            form: 'account/form',
            isSuperUser: 'auth/isSuperUser'
        })
    }
};
</script>

<style lang="sass" scoped>
.password-reset-flex-col
    display: flex
    .switch
        padding-right: 20px
    .input
        flex-grow: 1
</style>
